import script from "./diamondsSearchFormPresets.vue?vue&type=script&setup=true&lang=ts"
export * from "./diamondsSearchFormPresets.vue?vue&type=script&setup=true&lang=ts"

import "./diamondsSearchFormPresets.vue?vue&type=style&index=0&id=05304c91&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05304c91"]])

export default __exports__